module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Wine-6c77b7b7c6ae42fd7e644c941e85108d.svg";